import EstoreService from "@/services/EstoreService.js";
import { getField, updateField } from "vuex-map-fields";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    loading_voucher: false,
    loading: false,
    loadingOverlay: false,
    errors: null,
    orders: [],
    orderDetails: null,
    modal: { status: false },
    bankDetails: [],
    cart: null,
    checkout: null,
    voucher: null,
    billingAddress: null,
    paynamics: null,
    webDesign: {
      design: {
        button_text_color: "#fff",
        logo: null,
        main_color: "#ff8a00",
        merchant_uuid: "",
        published: "",
        title: "",
        updated_at: "",
        uuid: ""
      }
    },
    notWithinBranch: [],
    deliverPickUp: null,
    isFollowUpOrderSent: false,
    isCancellingOrder: false,
    cancelledOrderMsg: null,
    cancellationReasons: null,
    payMongoData: null,
    hideMap: false,
    isFullScreen: false,
    maxPage: 0,
    nextPage: 0,
    payMongoPaymentIntent: null,
    updateDeliveryErrors: null,
    ordersLoading: false,
    storeDetails: {},
    coordinates: null,
    hideDeliveryFee: true
  },
  mutations: {
    updateField,
    SET_MODAL(state, value) {
      state.modal.status = value.status;
    },
    SET_LOADING_VOUCHER(state, value) {
      state.loading_voucher = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_LOADING_OVERLAY(state, value) {
      state.loadingOverlay = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_STORE_DETAILS(state, details) {
      state.storeDetails = details;
    },
    SET_ORDERS(state, orders) {
      state.orders = orders;
    },
    SET_ORDER_DETAILS(state, orderDetails) {
      state.orderDetails = orderDetails;
    },
    SET_BANK_DETAILS(state, bankDetails) {
      state.bankDetails = bankDetails;
      state.cancellationReasons = bankDetails.details.cancellation_reasons;
    },
    SET_CART(state, cart) {
      if (state.hideDeliveryFee) {
        let deliveryFee = cart.data.fees.filter(fee => fee.name == 'Delivery_fee');
          deliveryFee.forEach(fee => {
            cart.data.computed_total -= (Math.floor(fee.calculated_amount * 100) / 100)
          });
      }
      state.cart = cart;
    },
    SET_CHECKOUT(state, checkout) {
      state.checkout = checkout;
    },
    SET_VOUCHER(state, voucher) {
      state.voucher = voucher;
    },
    SET_BILLING_ADDRESS(state, billingAddress) {
      state.billingAddress = billingAddress;
    },
    SET_PAYNAMICS(state, paynamics) {
      state.paynamics = paynamics;
    },
    SET_WEB_DESIGN(state, webDesign) {
      state.webDesign = webDesign;
    },
    SET_NOT_WITHIN_BRANCH(state, notWithinBranch) {
      state.notWithinBranch = notWithinBranch;
    },
    SET_DELIVER_PICKUP(state, deliverPickUp) {
      state.deliverPickUp = deliverPickUp;
    },
    SET_IS_FOLLOW_UP_ORDER_SENT(state, payload) {
      state.isFollowUpOrderSent = payload;
    },
    SET_CANCEL_ORDER(state, status) {
      state.isCancellingOrder = status;
    },
    SET_CANCELLED_ORDER_MSG(state, msg) {
      state.cancelledOrderMsg = msg;
    },
    SET_PAYMONGO_DATA(state, payload) {
      state.payMongoData = payload;
    },
    SET_HIDE_MAP(state, payload) {
      state.hideMap = payload;
    },
    SET_IS_FULL_SCREEN(state, payload) {
      state.isFullScreen = payload;
    },
    SET_MAX_PAGE(state, maxPage) {
      state.maxPage = maxPage;
    },
    SET_NEXT_PAGE(state, nextPage) {
      state.nextPage = nextPage;
    },
    SET_PAYMONGO_PAYMENT_INTENT(state, payload) {
      state.payMongoPaymentIntent = payload;
    },
    setUpdateDeliveryErrors(state, payload) {
      state.updateDeliveryErrors = payload;
    },
    setOrdersLoading(state, payload) {
      state.ordersLoading = payload;
    },
    resetProductsAndPagination(state) {
      state.products = null;
      state.maxPage = 0;
      state.nextPage = 0;
    },
    setCoordinates(state, { lat, lng }) {
      state.coordinates = {
        lat: lat,
        lng: lng
      };
    },
    setHideDeliveryFee(state, hide) {
      state.hideDeliveryFee = hide;
    }
  },
  getters: {
    getField,
    getDeliveryConfig(state) {
      return state.cart.list.map(obj => {
        return {
          brand: obj.brand_name,
          brand_uuid: obj.brand_uuid,
          branch: obj.branch_name,
          branch_uuid: obj.branch_uuid,
          deliveryType: obj.delivery_type,
          pickup_datetime: obj.pickup_datetime,
          fees: obj.fees
        };
      });
    },
    transactionId(state) {
      return state.checkout !== null ? state.checkout.order : null;
    },
    isCancellingOrder: state => state.isCancellingOrder,
    errors: state => state.errors,
    cancelledOrderMsg: state => state.cancelledOrderMsg,
    loading: state => state.loading,
    cancellationReasons: state => state.cancellationReasons,
    design: state =>
      state.webDesign && state.webDesign.design ? state.webDesign.design : {},
    payMongoPaymentData: state =>
      state.payMongoData ? state.payMongoData.payment_data : null,
    storeDetails: state => state.storeDetails,
    orders: state =>
      state.orders
        ? state.orders.map(order => {
            order.orders.map(item => {
              if (item.status === "payment_pending") item.status = "pending";

              if (item.delivery_type.toLowerCase().includes("pick")) {
                if (item.status === "dispatched") item.status = "pick_up";
                if (item.status === "delivered") item.status = "claimed";
              }
            });
            return order;
          })
        : [],
    orderDetails: state => {
      if (state.orderDetails) {
        state.orderDetails.orders.map(order => {
          if (order.status === "payment_pending") order.status = "pending";

          if (order.delivery_type.toLowerCase().includes("pick")) {
            if (order.status === "dispatched") order.status = "pick_up";
            if (order.status === "delivered") order.status = "claimed";
          }

          return order;
        });
      }

      return state.orderDetails;
    },
    cart: state => state.cart
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async getStoreDetails({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.getStoreDetails(request);
        commit("SET_STORE_DETAILS", response.details);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getOrders({ commit }, request) {
      commit("setOrdersLoading", true);

      try {
        commit("SET_ORDERS", []);
        const response = await EstoreService.getOrders(request);
        commit("SET_ORDERS", response.list);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("setOrdersLoading", false);
      }
    },
    async getOrderDetails({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        if (request.header.Authorization) {
          const { list } = await EstoreService.getOrderDetails(request);
          commit("SET_ORDER_DETAILS", list);
        } else {
          const { data } = await EstoreService.getPublicOrderDetails(request);
          commit("SET_ORDER_DETAILS", data.list);
        }
      } catch (errors) {
        commit("SET_ERRORS", errors);
        if (errors.status === 404) router.push({ name: "404" });
      } finally {
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async addToCart({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        let response = await EstoreService.addToCart(request);
        commit("SET_CART", response);
        commit("SET_LOADING_OVERLAY", false);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_LOADING_OVERLAY", false);
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async editCart({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.editCart(request);
        commit("SET_CART", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async removeItem({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.removeItem(request);
        commit("SET_CART", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async viewCart({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        let response = await EstoreService.viewCart(request);
        const customer_info = {
          first_name: response.data.first_name,
          last_name: response.data.last_name,
          mobile_number: response.data.mobile_number,
          email: response.data.email
        }
        commit("SET_CART", response);
        commit("customer/SET_CUSTOMER_UUID", response.data.customer_uuid, { root: true });
        commit("customer/SET_INFO", customer_info, { root: true });
      } catch (errors) {
        commit("SET_ERRORS", errors);
        if (errors.status === 404
          || errors.status === 419
          || errors.status === 400) router.push({ name: "404" });
      } finally {        
        commit("SET_LOADING_OVERLAY", false);
        commit("SET_LOADING", false);
      }
    },
    async uploadCustomerDepositSlip({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        await EstoreService.uploadCustomerDepositSlip(request);
        commit("SET_LOADING", false);
      } catch (errors) {
        if (errors.errors.message == "P") {
          commit("SET_ERRORS", {
            errors: {
              file_upload: "Previous uploaded deposit slip not yet reviewed"
            }
          });
        } else if (
          errors.errors.message == "Sorry, You can only upload three times."
        ) {
          commit("SET_ERRORS", {
            errors: {
              file_upload: "Sorry, You can only upload three times."
            }
          });
        } else {
          commit("SET_ERRORS", errors);
        }
        commit("SET_LOADING", false);
      }
    },
    async checkout({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        let response;
        if (request.header.Authorization) {
          response = await EstoreService.checkout(request);
          commit("SET_CHECKOUT", response);
        } else {
          response = await EstoreService.publicCheckout(request);
          commit("SET_CHECKOUT", response.data);
        }
        commit("SET_ERRORS", null);
        if (Object.keys(response).includes("errors")) {
          commit("SET_ERRORS", response);
          commit("medpadala/SET_ERRORS", response.message, { root: true });
        }
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async verifyVoucher({ commit }, request) {
      commit("SET_LOADING_VOUCHER", true);
      try {
        let response = await EstoreService.verifyVoucher(request);
        commit("SET_VOUCHER", response);
        commit("SET_LOADING_VOUCHER", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING_VOUCHER", false);
      }
    },
    async applyVoucher({ commit }, request) {
      commit("SET_LOADING_VOUCHER", true);
      try {
        let response = await EstoreService.applyVoucher(request);
        commit("SET_CART", response);
        commit("SET_LOADING_VOUCHER", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING_VOUCHER", false);
      }
    },
    async removeVoucher({ commit }, request) {
      commit("SET_LOADING_VOUCHER", true);
      try {
        const response = await EstoreService.removeVoucher(request);
        commit("SET_CART", response);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING_VOUCHER", false);
      }
    },
    async updateDelivery({ commit }, request) {
      commit("SET_LOADING", true);
      commit("setUpdateDeliveryErrors", null);

      try {
        const response = await EstoreService.updateDelivery(request);

        commit("SET_CART", response);
      } catch (errors) {
        commit("setUpdateDeliveryErrors", errors.errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async addBilling({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.addBilling(request);
        commit("SET_BILLING_ADDRESS", response);
        commit("SET_ERRORS", null);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async paynamics({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.paynamics(request);
        commit("SET_PAYNAMICS", response);
        commit("SET_ERRORS", null);
        commit("SET_LOADING", false);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async gcashPaynamics({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.gcashPaynamics(request);
        commit("SET_PAYNAMICS", response);
        commit("SET_ERRORS", null);
        commit("SET_LOADING", false);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getWebDesign({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.getWebDesign(request);

        if (response.design !== null) commit("SET_WEB_DESIGN", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async checkPaymentStatus({ commit }, request) {
      try {
        let response = await EstoreService.checkPaymentStatus(request);
        commit("SET_ERRORS", null);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async checkBranches({ commit }, request) {
      try {
        let response = await EstoreService.checkBranches(request);
        commit("SET_NOT_WITHIN_BRANCH", response.list);
        commit("SET_ERRORS", null);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async followUpOrder({ commit }, request) {
      try {
        const response = await EstoreService.followUpOrder(request);

        commit(
          "SET_IS_FOLLOW_UP_ORDER_SENT",
          response["follow_up_sent"] ? response["follow_up_sent"] : false
        );
        commit("SET_ERRORS", null);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async cancelOrder({ commit }, request) {
      commit("SET_CANCEL_ORDER", true);
      try {
        const response = await EstoreService.cancelOrder(request);
        commit("SET_CANCELLED_ORDER_MSG", {
          message: response.message,
          order_status: response.order_status
        });
        commit("SET_ERRORS", null);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_CANCEL_ORDER", false);
      }
    },
    // MEDPadala
    async medPadalaBalanceInquiry({ commit }, request) {
      commit("medpadala/SET_LOADING", true, { root: true });
      try {
        const response = await EstoreService.medPadalaBalanceInquiry(request);
        commit("medpadala/SET_ERRORS", null, { root: true });
        commit("medpadala/SET_MEDPADALA_DATA", response, { root: true });
      } catch (errors) {
        commit("medpadala/SET_ERRORS", errors.errors, { root: true });
      } finally {
        commit("medpadala/SET_LOADING", false, { root: true });
      }
    },
    async medPadalaSaveAmount({ commit }, request) {
      commit("medpadala/SET_LOADING", true, { root: true });
      try {
        const response = await EstoreService.medPadalaSaveAmount(request);
        commit("medpadala/SET_ERRORS", null, { root: true });
        return response;
      } catch (errors) {
        commit("medpadala/SET_ERRORS", errors.errors, { root: true });
      } finally {
        commit("medpadala/SET_LOADING", false, { root: true });
      }
    },
    async medPadalaRemove({ commit }, request) {
      commit("medpadala/SET_LOADING", true, { root: true });
      try {
        const response = await EstoreService.medPadalaRemove(request);
        commit("medpadala/SET_ERRORS", null, { root: true });
        return response;
      } catch (errors) {
        commit("medpadala/SET_ERRORS", errors.errors, { root: true });
      } finally {
        commit("medpadala/SET_LOADING", false, { root: true });
      }
    },
    async payViaPayMongo({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);
      commit("SET_PAYMONGO_DATA", null);

      try {
        const response = await EstoreService.payViaPayMongo(request);

        commit("SET_PAYMONGO_DATA", response);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getPayMongoPaymentIntent({ commit }, request) {
      commit("SET_ERRORS", null);

      try {
        const response = await EstoreService.getPayMongoPaymentIntent(request);

        commit(
          "SET_PAYMONGO_PAYMENT_INTENT",
          response.data ? response.data : null
        );
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    // eslint-disable-next-line
    async deletePayMongoPaymentMethod({ }, request) {
      try {
        await EstoreService.deletePayMongoPaymentMethod(request);
      } catch (errors) {
        console.log(errors);
      }
    },
    async updateLocation({ commit }, request) {
      try {
        await EstoreService.updateLocation(request);
        commit("SET_ERRORS", null);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
  }
};
